export const directoryLogoPath: string = '/Blob/images/brands'
export const defaultLogoPath: string = `${directoryLogoPath}/covista.svg`
export const mapBrands: Map<string, string> = new Map([
    ['chamberlain-university', 'png'],
    ['ross-university-school-of-medicine', 'png'],
    ['ross-university-school-of-veterinary-medicine', 'png'],
    ['american-university-of-the-caribbean', 'png'],
    ['walden-university', 'png'],
    ['covista', 'png'],
])